import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, ElementRef, OnDestroy, OnInit, Signal, inject, viewChild } from '@angular/core';
import {MealKitIconButtonComponent, MealKitStarNotationModule, MealKitTextInput} from '@yoni/mealcomponents-lib';
import {ModalService} from '../../../Services/modal.service';
import {
  AddCommentBody,
  AddRatingBody,
  Allergen,
  CourseItem,
  QdmService,
  RankItem,
  ServiceItem
} from '../../../Services/qdm.service';
import {CartItem, CartService} from 'app/Cart/CartService';
import {PipeNumberFormat} from 'app/Components/Pipes/PipeNumberFormat';
import {SmallBadgeComponent} from "../../SmallBadge/SmallBadge.component";
import {Subscription} from 'rxjs';
import {EnvDescriptor, EnvLoader} from 'app/Environment/EnvLoader';
import {RestaurantHelper} from "../../../Utils/RestaurantHelper";
import {LocalStorageHelper} from "../../../Utils/LocalStorageHelper";
import {AuthService, User} from "../../../Services/auth.service";
import {GreenActionButtonComponent} from "../../green-action-button/green-action-button.component";
import {FormsModule} from "@angular/forms";
import {ActionButtonComponent} from "../../action-button/action-button.component";
import {WeekMenuDisplayComponent} from '../../WeekMenuDisplay/WeekMenuDisplay.component';

@Component({
  imports: [MealKitIconButtonComponent, PipeNumberFormat, SmallBadgeComponent, MealKitTextInput, GreenActionButtonComponent, FormsModule, ActionButtonComponent],
  selector: 'modal-course-details',
  templateUrl: 'ModalCourseDetails.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['ModalCourseDetails.component.scss']
})

export class ModalCourseDetailsComponent implements OnInit, OnDestroy, AfterViewInit {
  private variables = inject<any>('variables' as any);
  protected modal = inject(ModalService);
  private cartService = inject(CartService);
  private qdm = inject(QdmService);
  private cdr = inject(ChangeDetectorRef);
  private auth = inject(AuthService);

  protected readonly emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  readonly fadeInContainer = viewChild('fadeInContainer', { read: ElementRef });

  course: CourseItem | undefined;
  rank: RankItem | undefined;

  service: ServiceItem | null = null;
  restaurantId: number = -1;
  childId: number = -1;
  date: Date = new Date();
  rstIdFromService: number = -1;

  allergens: Allergen[] = [];

  sub: Subscription = new Subscription();
  mode: "week" | "day" = "day";
  alreadyGivenStars: number | undefined = undefined;

  readonly note = viewChild.required<MealKitStarNotationModule>("note");

  readonly emailInput = viewChild.required<MealKitTextInput>("email");


  readonly commentEmail = viewChild.required<MealKitTextInput>("commentEmail");

  readonly commentText = viewChild.required<MealKitTextInput>("commentText");

  protected restaurantHelper?: RestaurantHelper;
  protected askForEmail: boolean = false;
  protected email: string = "";
  protected isEmailValid: Signal<boolean> = computed(() => this.emailRegex.test(this.email));

  protected showCommentModal: boolean = false;
  private comment: string = "";
  private cstId: number | undefined;
  protected alreadyCommented: { email: string; comment: string } | undefined;
  protected remaining: number = 999;
  protected qdmApiUrl: string = "";

  isAcceptPayment: boolean = false;

  iconsServices: { [key: number]: { url: string; bg: string } } = {};
  imagesWithErrors: Set<number> = new Set();

  private readonly ALT_BACKGROUND_COLORS = [
    '#F8B133', // orange-1
    '#8ABD27', // vert-1
    '#E57373', // rose-1
    '#64B5F6', // bleu-1
    '#FFB74D', // orange-3
    '#81C784', // vert-3
    '#F48FB1', // rose-3
  ];

  ngAfterViewInit(): void {
    if (this.service && this.course) {
      this.alreadyGivenStars = LocalStorageHelper.getCourseNotation(this.restaurantId, this.service.id, this.course.id);
      this.alreadyCommented = LocalStorageHelper.getCourseCommentAndMail(this.restaurantId, this.service.id, this.course.id);

      if (this.alreadyGivenStars) {
        this.note().selectedStar = this.alreadyGivenStars;
      }
    }
  }


  ngOnInit() {
    const ent = this.qdm.selectedEnterpriseSubject.value;

    if (!ent) {
      this.isAcceptPayment = false;
    } else {
      this.isAcceptPayment = ent.isAcceptPayment;
    }

    this.course = this.variables.course;
    this.service = this.variables.service;
    this.restaurantId = this.variables.restaurantId;
    this.childId = this.variables.childId;
    this.date = this.variables.date;
    this.rank = this.variables.rank;
    this.restaurantHelper = this.variables.restaurantHelper;
    this.mode = this.variables.mode;
    this.iconsServices = this.variables.iconsServices;

    if (this.variables.remaining) {
      this.remaining = this.variables.remaining;
    }

    const envDescriptor: EnvDescriptor = EnvLoader.load();
    this.qdmApiUrl = envDescriptor.qdmApiUrl;

    const user: User | undefined = this.auth.userSubject.value
    const resto = this.qdm.selectedRestaurantSubject.value;

    this.cstId = resto?.cstID;

    const isUsePassword: boolean = resto?.is_use_password || false;

    if (isUsePassword) {
      this.email = user?.email || "";
    }

    this.rstIdFromService = this.variables.rstIdFromService;
    this.qdm.fetchAllergens(this.service?.rst_id || 0).then((data) => {
      this.allergens = data;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  removeFadeInFromContainer() {
    const fadeInContainer = this.fadeInContainer();
    if (!fadeInContainer) {
      return;
    }

    fadeInContainer.nativeElement.classList.remove("fadeIn");
  }

  close(ev: MouseEvent | null) {
    if (ev === null) {
      this.modal.close();
    } else if (ev.target == ev.currentTarget) {
      this.modal.close();
    }
  }

  quantityPresentInCart(itemId: number): number {
    if (this.service == null) return 0;

    return this.cartService.quantityPresentInCart(itemId, this.service.id, this.restaurantId, this.childId, this.date);
  }

  /**
   *
   * @param item CourseItem (extract de la liste des services du QDM API) à transform
   * @returns
   */
  cartItem(item: CourseItem): CartItem | undefined {
    if (this.service === null) return undefined;
    if (!this.rank) return undefined;

    const qty = this.cartService.quantityPresentInCart(item.id, this.service.id, this.restaurantId, this.childId, this.date);

    return {
      displayedPrice: item.price || 0,
      id: item.id,
      name: item.name,
      image: item.image,
      quantity: qty,
      rankId: this.rank.family_id || -1,
      rankName: this.rank.name,
      isMeatFullCourse: item.isMeatFullCourse,
      isVeganFullCourse: item.isVeganFullCourse,
      gpaoId: item.gpaoId,
      isExtraItem: item.is_extra,
      rankSort: parseInt(this.rank.rank || '0')
    };
  }

  getAllergenByName(name: string): Allergen | undefined {
    return this.allergens.find(a => a.name === name);
  }

  getAllergenByIndex(index: number): Allergen | undefined {
    return this.allergens[index];
  }

  generateAllergenImage(allergenId: number): string {
    let env = (globalThis as any).env as EnvDescriptor;
    if (!env) {
      env = EnvLoader.load();
    }


    const allergen = this.allergens[allergenId];
    if (!allergen) return "allergen not found";

    return `${env.qdmApiUrl}/${this.allergens[allergenId].logo}`;
  }

  generateImageUrl(imageName: string, id: number): string {
    const env = (globalThis as any).env;

    if (!this.service) return "/assets/images/plats/default_image_menu.webp";

    return `${env.qdmApiUrl}/upload/course_images/${this.service.rst_id}/image_${id}`;
  }

  normalizeUrl(url: string): string {
    return url.normalize('NFC');
  }

  lastStarCount: number = 0;

  getBackgroundColor(): string {
    if (!this.course || !this.service || !this.rank) return 'transparent';

    const icon = this.iconsServices[this.rank.family_id || this.rank.id || 0];

    return (
      (icon?.bg ? `#${icon.bg}` : undefined) ||
      this.ALT_BACKGROUND_COLORS[
      this.service.id % this.ALT_BACKGROUND_COLORS.length
        ]
    );
  }

  onImageError(ev: ErrorEvent) {
    if (!this.course) return;

    const target = ev.target as HTMLImageElement;
    this.imagesWithErrors.add(this.course.id);

    // Remplacer l'image
    this.replaceImageWithIcon(target);
  }

  private replaceImageWithIcon(targetElement: HTMLImageElement) {
    if (!this.course || !this.rank) return;

    const familyId = this.rank.family_id || this.rank.id || 0;
    const icon = this.iconsServices[familyId];

    // Obtenir le parent de l'image
    const containerDiv = targetElement.parentElement;
    if (!containerDiv) return;

    // Sauvegarder les éléments de notation et commentaires avant de vider le conteneur
    const ratingContainer = containerDiv.querySelector('.absolute.left-4.bottom-4');
    const closeButton = containerDiv.querySelector('mk-icon-button');

    // Vider le conteneur
    containerDiv.innerHTML = '';

    if (!icon || !icon.bg || !icon.url) {
      // Fallback vers l'image par défaut si les icônes ne sont pas disponibles
      const imgElement = document.createElement('img');
      imgElement.src = WeekMenuDisplayComponent.IMAGE_NOT_FOUND_URL || '/assets/images/plats/default_image_menu.webp';
      imgElement.className = 'absolute w-full h-full object-cover';
      imgElement.alt = this.course.name;
      imgElement.style.transform = 'scale(1.2)';
      containerDiv.appendChild(imgElement);
    } else {
      // Créer un nouveau div avec l'image d'icône
      const iconDiv = document.createElement('div');
      iconDiv.style.backgroundColor = `#${icon.bg}`;
      iconDiv.className = 'absolute w-full h-full object-cover relative overflow-hidden';
      iconDiv.innerHTML = `
        <img src="${icon.url}" class="w-36 object-cover absolute bottom-0 left-0 -translate-x-6 translate-y-6" alt="Icon" />
      `;

      containerDiv.appendChild(iconDiv);
    }

    // Réinjecter les éléments sauvegardés s'ils existent
    if (ratingContainer) {
      containerDiv.appendChild(ratingContainer);
    }

    if (closeButton) {
      containerDiv.appendChild(closeButton);
    }

    this.cdr.detectChanges();
  }

  private addRatingContainer(containerDiv: HTMLElement) {
    if (!this.restaurantHelper?.isCourseRatingEnabled() && !this.restaurantHelper?.isCourseCommentEnabled()) {
      return;
    }

    // Créer le conteneur des étoiles et commentaires
    const ratingContainer = document.createElement('div');
    ratingContainer.className = 'absolute left-4 bottom-4 flex items-center gap-2 px-4 py-2 bg-white rounded';
    containerDiv.appendChild(ratingContainer);

    // Le contenu sera ajouté automatiquement par Angular
    this.cdr.detectChanges();
  }

  noteCourse(starCount: number) {
    this.lastStarCount = starCount;
    if (!this.service) {
      return;
    }

    if (!this.course) {
      return;
    }

    const note: number | undefined = LocalStorageHelper.getCourseNotation(this.restaurantId, this.service.id, this.course.id);

    if (note !== undefined) {
      return;
    }

    if (this.email === "") {
      // on est pas connectés, il faut demander le mail
      this.askForEmail = true;
      return;
    }

    this.sendNote(starCount);
  }

  private sendNote(starCount: number) {
    if (!this.service) return;
    if (!this.course) return;

    LocalStorageHelper.noteCourse(this.restaurantId, this.service.id, this.course.id, starCount);

    const body: AddRatingBody = {
      email: this.email,
      svc_id: this.service!.id,
      rst_id: this.restaurantId,
      rating: starCount,
      crs_id: this.course!.id
    }

    this.qdm.addRating(body).then(() => {
      this.askForEmail = false;
    });
  }

  private sendComment(email: string, comment: string, inst: ActionButtonComponent) {
    if (!this.course) return;
    if (!this.service) return;
    if (!this.cstId) return;

    LocalStorageHelper.commentCourse(this.restaurantId, this.service.id, this.course.id, email, comment);

    const body: AddCommentBody = {
      email: this.email,
      svc_ID: this.service!.id,
      rst_id: this.restaurantId,
      "comment": comment,
      crs_id: this.course!.id,
      category: 2,
      cst_id: this.cstId,
      categorie: 2
    }

    inst._state.set("loading");
    inst._displayedLabel.set("Envoi en cours...");

    this.qdm.addComment(body).then(() => {
      this.showCommentModal = false;
    })
  }

  _handle_setEmail() {
    const inst: ActionButtonComponent = (this as unknown as ActionButtonComponent);
    const data = inst.data() as ModalCourseDetailsComponent;
    const emailInput = data.emailInput();
    if (!data.emailRegex.test(emailInput.value)) {
      inst._state.set("failed");
      inst._displayedLabel.set("Email invalide");

      setTimeout(() => {
        inst._state.set("default");
        inst._displayedLabel.set(inst.baseLabel());
      }, 1000);
      return;
    }

    inst._state.set("loading");
    inst._displayedLabel.set("Envoi...");

    data.email = emailInput.value;
    data.sendNote(data.lastStarCount);
  }

  _handle_comment() {
    const inst: ActionButtonComponent = (this as unknown as ActionButtonComponent);
    const data = inst.data() as ModalCourseDetailsComponent;
    const commentEmail = data.commentEmail();
    if (!data.emailRegex.test(commentEmail.value)) {
      inst._state.set("failed");
      inst._displayedLabel.set("Email invalide");

      setTimeout(() => {
        inst._state.set("default");
        inst._displayedLabel.set(inst.baseLabel());
      }, 1000);
      return;
    }

    inst._state.set("loading");
    inst._displayedLabel.set("Envoi...");

    data.email = commentEmail.value;
    data.comment = data.commentText().value;
    data.sendComment(data.email, data.comment, inst);
  }

  _closeComments() {
    const inst: ActionButtonComponent = (this as unknown as ActionButtonComponent);
    const data = inst.data() as ModalCourseDetailsComponent;

    data.showCommentModal = false;
  }

  closeAskForEmail(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.askForEmail = false;
      this.note().selectedStar = 0;
    }
  }

  closeCommentModal(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.showCommentModal = false;
    }
  }
}
